import React from 'react';
import proptypes from 'prop-types';
import { Stack, Typography } from '@metarouter-private/mr-mui';
import DrawerHeaderControls from './DrawerHeaderControls';

const DrawerHeader = ({ onCloseDrawer }) => {
  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={2}>
      <Typography variant="h6">Test Playbook</Typography>
      <DrawerHeaderControls onCloseDrawer={onCloseDrawer} />
    </Stack>
  );
};
export default DrawerHeader;

DrawerHeader.propTypes = {
  onCloseDrawer: proptypes.func.isRequired,
};
